import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'beautyapp-questionnaire-add-edit',
    templateUrl: './questionnaire-add-edit.component.html',
    styleUrls: ['./questionnaire-add-edit.component.scss']
})
export class QuestionnaireAddEditComponent implements OnInit {
  @Input() userId?: string;

  constructor() {}

  ngOnInit(): void {}
}
